module.exports = function({ addUtilities, theme }) {
  addUtilities(
    {
      '.style-display': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.display'),
        fontWeight: theme('fontWeight.semibold'),
      },
      '.style-display-bold': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.display'),
        fontWeight: theme('fontWeight.bold'),
      },

      '.style-headline': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.giant'),
        fontWeight: theme('fontWeight.semibold'),
      },
      '.style-headline-bold': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.giant'),
        fontWeight: theme('fontWeight.bold'),
      },

      '.style-title': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.huge'),
        fontWeight: theme('fontWeight.semibold'),
      },
      '.style-title-bold': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.huge'),
        fontWeight: theme('fontWeight.bold'),
      },

      '.style-title-sm': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.xl'),
        fontWeight: theme('fontWeight.semibold'),
      },
      '.style-title-sm-bold': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.xl'),
        fontWeight: theme('fontWeight.bold'),
      },
      '.style-title-xs': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.xl'),
        fontWeight: theme('fontWeight.semibold'),
      },
      '.style-title-xs-bold': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.base'),
        fontSize: theme('fontSize.xl'),
        fontWeight: theme('fontWeight.bold'),
      },

      '.style-subtitle': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.lg'),
        fontWeight: theme('fontWeight.regular'),
      },
      '.style-subtitle-bold': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.lg'),
        fontWeight: theme('fontWeight.bold'),
      },
      '.style-subtitle-sm-bold': {
        fontFamily: theme('fontFamily.highlight'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.md'),
        fontWeight: theme('fontWeight.bold'),
      },

      '.style-body': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.sm'),
        fontWeight: theme('fontWeight.regular'),
      },
      '.style-body-bold': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.sm'),
        fontWeight: theme('fontWeight.bold'),
      },
      '.style-body-larger-bold': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.medium'),
        fontSize: theme('fontSize.xl'),
        fontWeight: theme('fontWeight.bold'),
      },
      '.style-body-sm': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.long'),
        fontSize: theme('fontSize.xs'),
        fontWeight: theme('fontWeight.regular'),
      },
      '.style-body-sm-bold': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.long'),
        fontSize: theme('fontSize.xs'),
        fontWeight: theme('fontWeight.bold'),
      },

      '.style-overline': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.long'),
        fontSize: theme('fontSize.nano'),
        fontWeight: theme('fontWeight.regular'),
      },
      '.style-overline-underline': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.long'),
        fontSize: theme('fontSize.nano'),
        fontWeight: theme('fontWeight.regular'),
        textDecoration: 'underline',
      },
      '.style-overline-bold': {
        fontFamily: theme('fontFamily.base'),
        lineHeight: theme('lineHeight.long'),
        fontSize: theme('fontSize.nano'),
        fontWeight: theme('fontWeight.bold'),
      },
    },
    ['responsive']
  );
};
